import { Outlet } from 'react-router-dom';
// components
import Header from './header';
import Footer from './footer';
// ui
import { Box, ContentBox } from '../../ui';
//////////////////////////////////////////////////

const AppLayout = () => (
  <Box>
    <Header />
    <ContentBox>
      <Outlet />
    </ContentBox>
    <Footer />
  </Box>
);

export default AppLayout;
